import { DateTime } from 'luxon';

export const getOrderDelayTimeInDaysFromRetentionDate = (retentionDate: DateTime) =>
   DateTime.now().startOf('day').diff(retentionDate.startOf('day'), 'days').days;
